import React, { MouseEventHandler } from 'react';
import { Refer } from 'flow/types/Pbx';
import { TypedMap } from 'flow/types/TypedMap';
import { isEmptyNullOrUndefined } from 'flow/utils';
import PbxListItem from './PbxListItem';
import { RowMarking } from './BaseListItem';

interface Props {
    item: TypedMap<Refer>;
    onClick: MouseEventHandler;
    marking?: RowMarking;
}

const ListItemPbxConnection = ({ item, onClick, marking }: Props) => (
    <PbxListItem
        onClick={onClick}
        marking={marking}
        type="connection"
        title={
            isEmptyNullOrUndefined(item.get('description'))
                ? item.getIn(['number', 'number'])
                : item.get('description')
        }
        phoneNumber={item.getIn(['number', 'number'])}
    />
);

export default ListItemPbxConnection;
